/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
// import { actions } from './actions/users-actions'
// import { mutations } from './mutations/user-mutations'
import { actions } from './store/actions'
import { mutations } from './store/mutations'
import getters from "./store/getters";
import approver from './store/modules/approver'
import users from './store/modules/users'
import userApplication from './store/modules/userApplication'
import userCompany from './store/modules/userCompany'
import userRole from './store/modules/userRole'
import application from './store/modules/application'
import companies from './store/modules/companies'
import expenses from './store/modules/expenses'
import expensesItems from './store/modules/expensesItems'
import projects from './store/modules/projects'
import branches from './store/modules/branches'
import restrictions from './store/modules/restrictions'
import validators from './store/modules/validators'
import settings from './store/modules/settings'
import catalogs from './store/modules/catalogs'
import roles from './store/modules/roles'
import categories from './store/modules/categories'
import travelTypes from './store/modules/travelTypes'
import areas from './store/modules/areas'
import conciliation from './store/modules/conciliation'
import toReconcile from './store/modules/toReconcile'
import reconciled from './store/modules/reconciled'
import missing from './store/modules/missing'
import excluded from './store/modules/excluded'
import areasUsers from './store/modules/areasUsers'
import workflow from './store/modules/workflow'
import permissions from './store/modules/permissions'
import substitutes from './store/modules/substitutes'
import subscriptions from './store/modules/subscriptions'
import history from './store/modules/history'
import expensesApproved from './store/modules/user.expensesApproved'
import expensesValidate from './store/modules/expensesValidate'
import notifications from './store/modules/notifications'
import expensesRejected from './store/modules/user.expensesRejected'
import missingReserveExpenses from './store/modules/missingReserveExpenses';
import satXmlDownload from './store/modules/satXmlDownload'
import reportsType from './store/modules/reportstype'
import expenseDetailEmployee from './store/modules/expenseDetailEmployee'
import keywords from './store/modules/keywords'
import annualExpensesReport from './store/modules/annualExpensesReport'
import annualExpensesReportBranch from './store/modules/annualExpensesReportBranch'
import reportExpensesCategoryBranch from './store/modules/reportExpensesCategoryBranch'
import reportsconcept from './store/modules/reportsconcept'
import reportComparative from './store/modules/reportComparative'
import reportExpenseTracking from './store/modules/reportExpenseTracking'
import reportFuel from './store/modules/reportFuel'
import expensesPayable from './store/modules/expensesPayable'
import annualExpensesByEmployedReport from './store/modules/annualExpensesByEmployedReport'
import expensesPaidRoute from './store/modules/expensesPaid'
import wizard from './store/modules/wizard'
import advances from './store/modules/advances'
import dashboard from './store/modules/dashboard'
import pettyCash from './store/modules/pettyCash'
import requestPettyCash from './store/modules/requestPettyCash'
import amexCard from './store/modules/amexCard';
import verifyEFOS from './store/modules/verifyEFOS'
import reservations from './store/modules/reservations'
import viatics from './store/modules/viatics'
import cashier from './store/modules/cashier'
import representatives from './store/modules/representatives';
import generalSearch from './store/modules/generalSearch'
import vehicles from './store/modules/vehicles'
import advancesRequest from './store/modules/advancesRequest'

import approvals from './modules/approvals/store/approvals'
import vendors from './store/modules/vendors'

Vue.use(Vuex)

export const userState = JSON.parse(localStorage.getItem('token'))
export const loginState = userState === null
export const userLogged = {}
export const notificationsState = null
export const totalNotView = null
export const search = ''
export const type = ''
export const paginated = {
  item: null,
  pagination: null
}

const state = {
  userState,
  loginState,
  userLogged,
  notificationsState,
  totalNotView,
  search,
  type,
  paginated
}

export const store = new Vuex.Store({
  modules: {
    approver,
    users,
    userApplication,
    userCompany,
    userRole,
    application,
    companies,
    expenses,
    expensesItems,
    projects,
    branches,
    restrictions,
    validators,
    settings,
    catalogs,
    roles,
    categories,
    travelTypes,
    areas,
    conciliation,
    toReconcile,
    reconciled,
    excluded,
    missing,
    areasUsers,
    workflow,
    permissions,
    substitutes,
    subscriptions,
    history,
    expensesApproved,
    expensesValidate,
    notifications,
    expensesRejected,
    satXmlDownload,
    reportsType,
    expenseDetailEmployee,
    keywords,
    annualExpensesReport,
    annualExpensesReportBranch,
    reportExpensesCategoryBranch,
    reportsconcept,
    reportComparative,
    reportExpenseTracking,
    expensesPayable,
    annualExpensesByEmployedReport,
    expensesPaidRoute,
    wizard,
    advances,
    dashboard,
    pettyCash,
    requestPettyCash,
    amexCard,
    verifyEFOS,
    reservations,
    viatics,
    cashier,
    representatives,
    generalSearch,
    vehicles,
    approvals,
    reportFuel,
    advancesRequest,
    vendors,
    missingReserveExpenses
  },
  state,
  actions,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/store.js